/** Labels the receipt must never show as a positive amount (docs/edge/dual-pricing.md). */
const FEE_LABEL = /\b(card\s*fee|surcharge|service\s*fee)\b/i;
/**
 * DualPrice is the customer-facing half of dual pricing (#1353): the menu stores cash prices, the
 * posted regular price is the card price (cash + percent markup, half-up per item), and paying cash
 * takes the difference off. Mirrors backend domain.DualPricing; the server stays the authority on
 * what is charged, this only decides what the screens show.
 */
export class DualPrice {
    bips;
    static MAX_BIPS = 500;
    static OFF = new DualPrice(0);
    constructor(bips) {
        this.bips = bips;
    }
    /** Anything but an integer in 1..500 means off (the backend treats an invalid setting as off). */
    static fromBips(raw) {
        if (typeof raw !== "number" || !Number.isInteger(raw) || raw <= 0 || raw > DualPrice.MAX_BIPS)
            return DualPrice.OFF;
        return new DualPrice(raw);
    }
    get active() {
        return this.bips > 0;
    }
    /** (cash * (10000 + bips) + 5000) / 10000, integer division. */
    cardCents(cashCents) {
        if (!this.active)
            return cashCents;
        return Math.floor((cashCents * (10000 + this.bips) + 5000) / 10000);
    }
    cashSubtotal(lines) {
        return lines.reduce((s, l) => s + l.priceCents * l.quantity, 0);
    }
    cardSubtotal(lines) {
        return lines.reduce((s, l) => s + this.cardCents(l.priceCents) * l.quantity, 0);
    }
    /** What paying cash saves: card subtotal minus cash subtotal. */
    discountCents(lines) {
        return this.cardSubtotal(lines) - this.cashSubtotal(lines);
    }
    /** Server receipt rows verbatim, minus any positive fee-like row (never print a card fee). */
    static printableLines(lines) {
        return lines.filter((l) => !(FEE_LABEL.test(l.label) && l.amountCents > 0)).map((l) => ({ label: l.label, amountCents: l.amountCents }));
    }
}
//# sourceMappingURL=DualPrice.js.map